import { useMemo } from "react";
import { Button, Select, Stack, Text, TextInput } from "@NP-Webber/crm-kit/dist/next/index.js";
import { matchPreset, periodOptions, type Period } from "./periods";

/**
 * Turbo's PeriodBar (donationsReport): a quick-period Select (this month … Hebrew years) + from / to dates.
 * Empty from / to = no period. The period travels in saved views through the page (getExtraViewState).
 */
export function PeriodBar({
  value,
  onChange,
  label = "תקופה",
  allowEmpty = true,
}: {
  value: Partial<Period>;
  onChange: (p: { from: string; to: string }) => void;
  label?: string;
  allowEmpty?: boolean;
}) {
  const presets = useMemo(() => periodOptions(), []);
  const preset = matchPreset(value);
  const from = value.from ?? "";
  const to = value.to ?? "";
  return (
    <Stack dir="row" gap={8} align="center" wrap className="tb-periodbar">
      <Text variant="muted">{label}</Text>
      <Select
        aria-label="תקופה מהירה"
        style={{ minWidth: 190 }}
        value={preset}
        options={[{ value: "", label: from || to ? "טווח מותאם" : allowEmpty ? "כל התקופות" : "תקופה מהירה…" }, ...presets.map((p) => ({ value: p.value, label: p.label }))]}
        onChange={(v) => {
          const p = presets.find((x) => x.value === v);
          if (p) onChange({ from: p.from, to: p.to });
        }}
      />
      <Text variant="muted">מתאריך</Text>
      <TextInput type="date" aria-label="מתאריך" style={{ width: 150 }} value={from} max={to || undefined} onChange={(e) => onChange({ from: e.target.value, to })} />
      <Text variant="muted">עד</Text>
      <TextInput type="date" aria-label="עד תאריך" style={{ width: 150 }} value={to} min={from || undefined} onChange={(e) => onChange({ from, to: e.target.value })} />
      {allowEmpty && (from || to) ? (
        <Button size="sm" variant="ghost" icon="x" onClick={() => onChange({ from: "", to: "" })}>
          כל התקופות
        </Button>
      ) : null}
    </Stack>
  );
}
